// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n", ""]);
// Exports
exports.locals = {
	"primary-dark": "#e73b05",
	"primary": "#ff6040",
	"primary-light": "#ffe4df",
	"primary-extra-light": "#fff2f0",
	"secondary-dark": "#8292b1",
	"secondary": "#99a8c6",
	"secondary-light": "#d0dae9",
	"secondary-extra-light": "#eef4fc",
	"default-dark": "#898ca7",
	"default": "#b8baca",
	"default-light": "#ecedf5",
	"default-extra-light": "#f8f8f8",
	"warning-dark": "#d96800",
	"warning": "#fbab00",
	"warning-light": "#ffeba3",
	"warning-extra-light": "#fff5d1",
	"info-dark": "#0a82c6",
	"info": "#2eb6ea",
	"info-light": "#beebfc",
	"info-extra-light": "#dff5fe",
	"success-dark": "#069941",
	"success": "#3aaa35",
	"success-light": "#c6f1c3",
	"success-extra-light": "#e3f9e1",
	"danger-dark": "#cd0101",
	"danger": "#ff4141",
	"danger-light": "#ffcece",
	"danger-extra-light": "#ffe7e7",
	"text-primary": "#131a4f",
	"text-secondary": "#8292b1",
	"shadow-25": "rgba(184,186,202,0.25)",
	"shadow-50": "rgba(184,186,202,0.5)"
};
module.exports = exports;
